import { Calendar } from 'lucide-react';

import type { DomainInfo } from '@ballerine/digital-footprint-schemas';

import { DomainInfo as DomainDetails } from '../../composites';
import { ReportWrapper } from '../../report-shared/components';

type DomainDetailsSectionProps = {
  domainInfo?: DomainInfo | null;
  reportCreatedAt?: Date | string | null;
};

export const DomainDetailsSection = ({
  domainInfo,
  reportCreatedAt,
}: DomainDetailsSectionProps) => {
  return (
    <ReportWrapper
      title="Domain Details"
      Icon={Calendar}
      tooltip="WHOIS data and domain registration information analysis."
      showTooltip={false}
    >
      <DomainDetails domainInfo={domainInfo} reportCreatedAt={reportCreatedAt} />
    </ReportWrapper>
  );
};
